import GlobalStyle from '../GlobalTheme';

export default GlobalStyle;
